import { gql } from 'graphql-request'

export const CREATE_BOOK_BADGE = gql`
  mutation CreateBookBadge($createBadgeInput: CreateBadgeInput!) {
    createBookBadge(createBadgeInput: $createBadgeInput) {
      message
    }
  }
`
